import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { OnValueEditedSubject } from './input-editable.model';

@Component({
  selector: 'sha-input-editable',
  templateUrl: './input-editable.component.html',
  styleUrls: ['./input-editable.component.css']
})
export class InputEditableComponent implements OnInit, OnChanges {

  @Input() value = '';
  @Input() onlyNumbers = false;
  @Output() onValueEdited = new EventEmitter<OnValueEditedSubject>();
  @Output() onValidateValue = new EventEmitter<OnValueEditedSubject>();
  inputValue = '';
  isDisabled = true;
  errorMessage = '';

  constructor() { }

  ngOnInit() {
    this.inputValue = this.value;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value) {
      this.inputValue = changes.value.currentValue;
    }
  }

  public reloadValue() {
    this.inputValue = this.value;
  }

  public keyUp(event: any) {
    if (event.keyCode === 13) {
      // Enter
      this.saveEdition(event);
    } else if (event.keyCode === 27) {
      // ESC
      this.cancelEdition(event);
    }
  }

  public keyPressed(event: any) {
    if (this.onlyNumbers && event.which !== 8 && isNaN(+String.fromCharCode(event.which))) {
      event.preventDefault();
    }
  }

  public enableEdition(event: any, element: any) {
    this.isDisabled = false;
    setTimeout(() => {
      element.setSelectionRange(0, element.value.length);
      element.focus();
    });
  }

  public cancelEdition(event: any) {
    this.isDisabled = true;
    this.inputValue = this.value;
    this.errorMessage = '';
  }

  public saveEdition(event: any) {
    this.isDisabled = true;
    this.errorMessage = '';
    const subject = <OnValueEditedSubject>{
      oldValue: this.value,
      newValue: this.inputValue,
      isValid: true,
      errorMessage: this.errorMessage
    };
    this.onValueEdited.emit(subject);
  }

  public canSave() {
    const valueToValidate = <OnValueEditedSubject>{ oldValue: this.value, newValue: this.inputValue, isValid: true, errorMessage: '' };
    this.onValidateValue.emit(valueToValidate);
    this.errorMessage = valueToValidate.errorMessage;
    return valueToValidate.isValid && this.inputValue !== this.value && this.inputValue !== '';
  }

}




// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/input-editable/input-editable.component.ts